import { render, staticRenderFns } from "./orderId.vue?vue&type=template&id=41abbc84&lang=pug&"
import script from "./orderId.vue?vue&type=script&lang=ts&"
export * from "./orderId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports